import React, { useEffect,useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";
import { pdf  } from "@react-pdf/renderer";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";

import Global from "component/akunting/report/summary-jurnal/Global";
import MyReportsumjurnal from "component/utils/MyReportsumjurnal";


function SummaryJurnal() {
    const { user } = useAuth();
    const [loadingCoA, setLoadingCoA] = useState(false);

  useEffect(() => {
      document.title = "Green Hill Kemuning | Summary Jurnal";
      window.scrollTo(0, 0);
  }, []);

  const handleDownloadGlobal = async ({ startDate, endDate }) => {
    try {
      setLoadingCoA(true);
      const reg_desc = user?.company;
      const startDateObj = new Date(startDate);
      const formattedStartDate = `${String(startDateObj.getDate()).padStart(2, "0")}-${String(startDateObj.getMonth() + 1).padStart(2, "0")}-${startDateObj.getFullYear()}`;
      const endDateObj = new Date(endDate);
      const formattedEndDate = `${String(endDateObj.getDate()).padStart(2, "0")}-${String(endDateObj.getMonth() + 1).padStart(2, "0")}-${endDateObj.getFullYear()}`;

      const res = await axios.post(
        `${process.env.REACT_APP_API}/report-summary-global`,
        { reg_desc, dari: formattedStartDate, sampai: formattedEndDate }
      );

      const jsonData = res.data.data;
      const blob = await pdf(
        <MyReportsumjurnal data={jsonData} tanggalDari={formattedStartDate} tanggalSampai={formattedEndDate} userBy={user?.name || "Admin"} />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Laporan_Summary_Jurnal_Global.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Gagal mengambil data Summary Jurnal:", err);
      showError("Gagal mengambil data Summary Jurnal.");
    } finally {
      setLoadingCoA(false);
    }
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Summary Jurnal Management</h5>
                            </div>
                          </div>
                        </div>  
                        <Global
                          onDownload={(formData) => handleDownloadGlobal(formData)}
                          onLoading={loadingCoA}
                        />
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>    
    </div>
  );
}

export default SummaryJurnal;
